import { render, staticRenderFns } from "./NoticeIconView.vue?vue&type=template&id=08b11616&scoped=true"
import script from "./NoticeIconView.vue?vue&type=script&lang=js"
export * from "./NoticeIconView.vue?vue&type=script&lang=js"
import style0 from "./NoticeIconView.vue?vue&type=style&index=0&id=08b11616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b11616",
  null
  
)

export default component.exports